<template>
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <div v-if="!initializing" class="container superior">
    <div class="row">
      <div class="col">
        <h2 class="text-primary display-5 bold text-start">{{ $t('general.terminosCondiciones') }}</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="card card-body">
        <p v-sanitize-html="terminosCondiciones" class="translate"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import { useRoute } from 'vue-router';
  import { viajesGrupos } from '@/store_pinia/viajesGrupo';
  import HomeApiService from '@/services/api/HomeApiService';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { usePageMeta } from '@/composables/usePageMeta';

  const loadingStore = useLoadingStore();
  const { webPageSchema } = usePageMeta();
  const initializing = ref(true);
  const terminosCondiciones = ref('');
  const viajesGruposStore = viajesGrupos();
  const route = useRoute();

  async function fetchTerminosCondiciones() {
    try {
      loadingStore.show();
      const response = await HomeApiService.getTermsConditions();
      terminosCondiciones.value = response.texto;
    } catch (error) {
      console.error('Error al obtener los términos y condiciones:', error);
      terminosCondiciones.value = '';
    } finally {
      loadingStore.hide();
    }
  }

  async function initializeTerminosCondiciones() {
    try {
      loadingStore.show();
      if (route.params.viajeId) {
        await viajesGruposStore.fetchViajeSeleccionado(
          route.params.viajeId, route.query.codigo, route.query.codigoPrevisualizacion
        );
        const viaje = viajesGruposStore.getViajeSeleccionado;
        terminosCondiciones.value = viaje?.termsConditions || '';
      } else {
        await fetchTerminosCondiciones();
      }
    } catch (error) {
      console.error('Error:', error);
      terminosCondiciones.value = '';
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(() => {
    initializeTerminosCondiciones();
  });
</script>

<style scoped lang="scss">
  .card-body {
    border: none;
    padding: 2rem;
  }

  .superior {
    max-width: 1200px;
    margin: 0 auto;
    padding: 25px 0;
    padding-top: 11rem;
  }

  @media only screen and (max-width: 768px) {
    .superior {
      padding: 7rem 15px;
    }

    .card-body {
      padding: 1rem;
    }
  }
</style>
